/*
 * TC Whiskey QC fixes (PageFly pages).
 * Kept in the theme so a PageFly republish cannot overwrite them.
 *
 *  1. HTML video elements published without `controls`, with a decorative play
 *     icon that nothing was wired to.
 *  2. PageFly writes sizes="calc(100vw/3)" on carousel images because desktop
 *     shows three across. On a phone that makes the browser pick the 320w file
 *     and stretch it to full width, which is the "grainy on mobile" problem.
 *     Setting sizes to the element's real width lets it pick the 768w/1536w file.
 */
(function () {
  function fixVideos() {
    document.querySelectorAll('[data-pf-type^="HTML.Video"]').forEach(function (wrap) {
      var video = wrap.querySelector('video');
      if (!video || video.dataset.tcwVideoReady) return;
      video.dataset.tcwVideoReady = '1';

      video.setAttribute('playsinline', '');
      video.preload = 'metadata';
      video.controls = true;

      var icon = wrap.querySelector('svg');
      if (icon) icon.style.display = 'none';

      wrap.style.cursor = 'pointer';
      wrap.addEventListener('click', function () {
        if (!video.paused) return;
        var played = video.play();
        if (played && played.catch) played.catch(function () {});
      });
    });
  }

  function fixImageSizes() {
    document.querySelectorAll('.__pf img[srcset]').forEach(function (img) {
      var width = Math.ceil(img.getBoundingClientRect().width);
      if (width < 40) return;
      var wanted = width + 'px';
      if (img.getAttribute('sizes') !== wanted) img.setAttribute('sizes', wanted);
    });
  }


  /*
   * Ready to Drink: the "Apple · Cherry · Peach" line in each product section
   * becomes three buttons that switch the gallery photo (the gallery's own
   * arrows and thumbnails are hidden in tcw-qc-fixes.css). Photos are matched
   * to flavors by file name, so the product's media order does not matter.
   */
  var FLAVOR_NOTES = {
    spritz: {
      apple: 'Real cider. Crisp apple. Bourbon beneath the bubbles.',
      cherry: 'Tart cherry character with a bourbon backbone. Naturally Up North.',
      peach: 'Ripe peach, bright bubbles, and a little bourbon bite.'
    },
    sour: {
      apple: 'Real cider meets bourbon spice. Crisp, with something to say.',
      cherry: 'Northern Michigan cherries meet bourbon and a citrus twist. Our roots, in a can.',
      peach: 'Ripe peach meets barrel spice. Sweet and sour find common ground.'
    }
  };

  function flavorPickers() {
    var flavors = ['apple', 'cherry', 'peach'];
    var sections = document.querySelectorAll(
      '.template-suffix-ready-to-drink [id$="__rtd_spritz"], .template-suffix-ready-to-drink [id$="__rtd_sour"]'
    );
    sections.forEach(function (sec) {
      if (sec.dataset.tcwFlavors) return;
      var main = sec.querySelector('.main-image');
      var carousel = main && main.querySelector('carousel-slider');
      if (!carousel) return;
      var slider = carousel.querySelector('.slider');
      var slides = [].slice.call(carousel.querySelectorAll('.slider__item'));
      var byFlavor = {};
      slides.forEach(function (slide) {
        var img = slide.querySelector('img');
        var file = ((img && (img.getAttribute('src') || img.currentSrc)) || '').toLowerCase().split('/').pop();
        flavors.forEach(function (f) {
          if (file.indexOf(f) > -1 && !byFlavor[f]) byFlavor[f] = slide;
        });
      });
      var label = [].slice.call(sec.querySelectorAll('strong')).filter(function (el) {
        return /^\s*apple\s*[\u00b7\u2022]\s*cherry\s*[\u00b7\u2022]\s*peach\s*$/i.test(el.textContent);
      })[0];
      var available = flavors.filter(function (f) { return byFlavor[f]; });
      if (!label || !available.length) return;
      sec.dataset.tcwFlavors = '1';

      var bar = document.createElement('div');
      bar.className = 'tcw-flavors';
      bar.setAttribute('role', 'group');
      bar.setAttribute('aria-label', 'Flavor');
      available.forEach(function (f) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tcw-flavor';
        btn.dataset.flavor = f;
        btn.setAttribute('aria-pressed', 'false');
        btn.textContent = f.charAt(0).toUpperCase() + f.slice(1);
        bar.appendChild(btn);
      });
      var labelBlock = label.closest('p') || label;
      var note = labelBlock.nextElementSibling;
      var family = /rtd_spritz$/.test(sec.id) ? 'spritz' : 'sour';
      labelBlock.replaceWith(bar);

      var current = null;
      function show(flavor) {
        current = flavor;
        var x = byFlavor[flavor].offsetLeft;
        // Depending on theme CSS either the carousel or its inner slider is the scroller
        carousel.scrollLeft = x;
        if (slider) slider.scrollLeft = x;
        // The carousel sizes itself to slide[currentIndex]
        var index = carousel.slides ? carousel.slides.indexOf(byFlavor[flavor]) : -1;
        if (index > -1) {
          carousel.currentIndex = index;
          if (carousel.updateDynamicHeight) carousel.updateDynamicHeight();
        }
        main.dataset.flavor = flavor;
        if (note && FLAVOR_NOTES[family] && FLAVOR_NOTES[family][flavor]) {
          note.textContent = FLAVOR_NOTES[family][flavor];
        }
        [].forEach.call(bar.children, function (btn) {
          btn.setAttribute('aria-pressed', btn.dataset.flavor === flavor ? 'true' : 'false');
        });
      }

      bar.addEventListener('click', function (evt) {
        var btn = evt.target.closest('.tcw-flavor');
        if (btn) show(btn.dataset.flavor);
      });

      var active = slides.filter(function (s) { return s.classList.contains('is-active'); })[0];
      var start = available.filter(function (f) { return byFlavor[f] === active; })[0] || available[0];
      show(start);
      window.addEventListener('load', function () { show(current); });
      // Slide widths change with the window, so re-align to the chosen photo
      window.addEventListener('on:debounced-resize', function () { setTimeout(function () { show(current); }, 120); });
      // The carousel initialises lazily and resets itself to slide 0 when it does
      if (!carousel.hasAttribute('loaded')) {
        new MutationObserver(function (records, observer) {
          if (!carousel.hasAttribute('loaded')) return;
          observer.disconnect();
          show(current);
        }).observe(carousel, { attributes: true, attributeFilter: ['loaded'] });
      }
    });
  }

  function run() {
    fixVideos();
    fixImageSizes();
    flavorPickers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', fixImageSizes);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(fixImageSizes, 200);
  });
})();
